<template lang="html">
  <page size="A4">
    <div>
      <table v-for="item,index in agendaVote" :class="[setTableStyle(index), {'qrcodeExampleTable': item.isQrExample}]" :align="setTableAlign(index)">
        <tbody v-if="item.isQrExample">
          <tr>
            <td colspan="4" class="qrcodeExampleCell">
              <div class="qrcodeExampleContent">
                <img class="qrcodeExampleImage" src="/static/img/icons/QRCodeEX.jpg" alt="QR code example">
                <div class="qrcodeExampleText">แสดงความคิดเห็นหรือซักถาม <br><br> สแกน QR Code ระบบคำถาม</div>
              </div>
            </td>
          </tr>
        </tbody>
        <tbody v-else>
          <tr>
            <th rowspan="2">
              <qr-code style="margin: 9% 5%;" size="50" class="" error-level="L" :text="content=memberInfo.memberid + item.resultAgendaID"></qr-code>
              <!-- <span style="font-weight: bold; padding-top: 0px; font-size: 6px;">{{ memberInfo.memberid }}{{ item.resultAgendaID }}</span> -->
            </th>
            <th colspan="3">การประชุมสามัญผู้ถือหุ้นประจำปี {{ termYear.year }}</th>
          </tr>
          <tr>
            <td style="font-weight: bold; background-color: #E8E8E8;">
              วาระที่ {{ item.agenda }}
            </td>
            <td style="font-weight: bold; text-align: left; background-color: #E8E8E8;" class="tablea">
              {{ item.short_title }}
            </td>
          </tr>
          <tr>
            <td rowspan="2">
              <span style="font-weight: bold; padding-top: 0px; font-size: 6px;">{{ memberInfo.memberid }}{{ item.resultAgendaID }}</span>
              <span style="margin-bottom: 0px; font-weight: bold;">เลขทะเบียน</span>
              <span>{{ memberInfo.memberid }}</span>
              <!-- <span style="font-weight: bold;">เลขอ้างอิง</span>
              <span>{{ agendaVoteCard[index].refNumber }}</span> -->
            </td>
          </tr>
          <tr>
            <td style="height: 84.5px; table-layout: auto;">
              <span style="padding-top: 10px; padding-bottom: 5px; text-align: right;">
                <img class="imgckbox" src="/static/img/icons/ckbox.gif">
                เห็นด้วย
              </span>
              <span style="padding-top: 10px; padding-bottom: 5px; text-align: right">
                <img class="imgckbox" src="/static/img/icons/ckbox.gif">
                ไม่เเห็นด้วย
              </span>
              <span style="padding-top: 10px; text-align: right">
                <img class="imgckbox" src="/static/img/icons/ckbox.gif">
                งดออกเสียง
              </span>
            </td>
            <td style="text-align: left;" class="tablea">
              <span style="text-align: left">{{ setLengthName(memberInfo.fullname) }}</span>
              <span style="text-align: left">{{ setLengthName(memberInfo.proxyfullname) }}</span>
              <span style="text-align: left;">จำนวนหุ้น {{ setQShare(memberInfo.q_share) }}</span>
              <span style="text-align: left">ลงชื่อ ________________________(ผู้รับมอบฉันทะ)</span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </page>
</template>

<script>
import { Decode } from '@/services'
export default {
  data () {
    return {
      getItemMember: '',
      date: new Date().getFullYear() + 543,
      shareholder: [],
      memberInfo: [],
      agendaVote: [],
      processAgendaID: [],
      resultAgendaID: [],
      content: '',
      agendaVoteCard: [
        {
          'regisNumber': 4010008296,
          'refNumber': 1001,
          'agenda': 2,
          'subAgenda': '',
          'title': 'พิจารณารับรองรายงานการประชุมสามัญผู้ถือหุ้นประจำปี 2560',
          'regisName': 'วีระ เดชธำรง โดยบริษัทหลักทรัพย์จัดการกองทุน กรุงไทย จำกัด (มหาชน)',
          'regisProxyName': 'ชื่อผู้มอบฉันทะ',
          'shareholders': 662100
        },
        {
          'regisNumber': 4010008296,
          'refNumber': 1001,
          'agenda': 4,
          'subAgenda': '',
          'title': 'พิจารณาอนุมัติงบการเงินประจำปีสิ้นสุด ณ วันที่ 31 ธันวาคม 2560',
          'regisName': 'วีระ เดชธำรง โดยบริษัทหลักทรัพย์จัดการกองทุน กรุงไทย จำกัด (มหาชน)',
          'regisProxyName': 'ชื่อผู้มอบฉันทะ',
          'shareholders': 662100
        },
        {
          'regisNumber': 4010008296,
          'refNumber': 1001,
          'agenda': 5,
          'subAgenda': '',
          'title': 'พิจารณาจัดสรรกำไรสุทธิเป็นทุนสำรองตามกฎหมายและการจ่ายเงินปันผล',
          'regisName': 'วีระ เดชธำรง โดยบริษัทหลักทรัพย์จัดการกองทุน กรุงไทย จำกัด (มหาชน)',
          'regisProxyName': 'ชื่อผู้มอบฉันทะ',
          'shareholders': 662100
        },
        {
          'regisNumber': 4010008296,
          'refNumber': 1001,
          'agenda': 6,
          'subAgenda': 1,
          'title': 'พิจารณาเลือกตั้งกรรมการแทนกรรมการที่ออกตามวาระ นายมรกต เธียรมนตรี',
          'regisName': 'วีระ เดชธำรง โดยบริษัทหลักทรัพย์จัดการกองทุน กรุงไทย จำกัด (มหาชน)',
          'regisProxyName': 'ชื่อผู้มอบฉันทะ',
          'shareholders': 662100
        },
        {
          'regisNumber': 4010008296,
          'refNumber': 1001,
          'agenda': 6,
          'subAgenda': 2,
          'title': 'พิจารณาเลือกตั้งกรรมการแทนกรรมการที่ออกตามวาระ นายอนิรุทธ์ หิรัญรักษ์',
          'regisName': 'วีระ เดชธำรง โดยบริษัทหลักทรัพย์จัดการกองทุน กรุงไทย จำกัด (มหาชน)',
          'regisProxyName': 'ชื่อผู้มอบฉันทะ',
          'shareholders': 662100
        },
        {
          'regisNumber': 4010008296,
          'refNumber': 1001,
          'agenda': 6,
          'subAgenda': 3,
          'title': 'พิจารณาเลือกตั้งกรรมการแทนกรรมการที่ออกตามวาระ นางมรกต กุลธรรมโยธิน',
          'regisName': 'วีระ เดชธำรง โดยบริษัทหลักทรัพย์จัดการกองทุน กรุงไทย จำกัด (มหาชน)',
          'regisProxyName': 'ชื่อผู้มอบฉันทะ',
          'shareholders': 662100
        },
        {
          'regisNumber': 4010008296,
          'refNumber': 1001,
          'agenda': 6,
          'subAgenda': 4,
          'title': 'พิจารณาเลือกตั้งกรรมการแทนกรรมการที่ออกตามวาระ นางสาวนฤมล วังศธรธนคุณ',
          'regisName': 'วีระ เดชธำรง โดยบริษัทหลักทรัพย์จัดการกองทุน กรุงไทย จำกัด (มหาชน)',
          'regisProxyName': 'ชื่อผู้มอบฉันทะ',
          'shareholders': 662100
        },
        {
          'regisNumber': 4010008296,
          'refNumber': 1001,
          'agenda': 7,
          'subAgenda': '',
          'title': 'พิจารณาอนุมัติการกำหนดค่าตอบแทนกรรมการ ของวันที่ 21 เมษายน 2561',
          'regisName': 'วีระ เดชธำรง โดยบริษัทหลักทรัพย์จัดการกองทุน กรุงไทย จำกัด (มหาชน)',
          'regisProxyName': 'ชื่อผู้มอบฉันทะ',
          'shareholders': 662100
        },
        {
          'regisNumber': 4010008296,
          'refNumber': 1001,
          'agenda': 8,
          'subAgenda': '',
          'title': 'พิจารณาแต่งตั้งผู้สอบบัญชีและกำหนดค่าสอบบัญชีประจำปี 2561',
          'regisName': 'วีระ เดชธำรง โดยบริษัทหลักทรัพย์จัดการกองทุน กรุงไทย จำกัด (มหาชน)',
          'regisProxyName': 'ชื่อผู้มอบฉันทะ',
          'shareholders': 662100
        },
        {
          'regisNumber': 4010008296,
          'refNumber': 1001,
          'agenda': 9,
          'subAgenda': '',
          'title': 'พิจารณาอนุมัติการแก้ไขข้อบังคับ บริษัท อินเทอร์เน็ตประเทศไทย จำกัด(มหาชน)',
          'regisName': 'วีระ เดชธำรง โดยบริษัทหลักทรัพย์จัดการกองทุน กรุงไทย จำกัด (มหาชน)',
          'regisProxyName': 'ชื่อผู้มอบฉันทะ',
          'shareholders': 662100
        },
        {
          'regisNumber': 4010008296,
          'refNumber': 1001,
          'agenda': 10,
          'subAgenda': '',
          'title': 'สมมติว่ามี ชื่อวาระ เพื่อทดสอบปริ้นเตอร์ ประจำปี 2561',
          'regisName': 'วีระ เดชธำรง โดยบริษัทหลักทรัพย์จัดการกองทุน กรุงไทย จำกัด (มหาชน)',
          'regisProxyName': 'ชื่อผู้มอบฉันทะ',
          'shareholders': 662100
        },
        {
          'regisNumber': 4010008296,
          'refNumber': 1001,
          'agenda': 11,
          'subAgenda': '',
          'title': 'สมมติว่ามี ชื่อวาระ เพื่อทดสอบปริ้นเตอร์ ประจำปี 2561',
          'regisName': 'วีระ เดชธำรง โดยบริษัทหลักทรัพย์จัดการกองทุน กรุงไทย จำกัด (มหาชน)',
          'regisProxyName': 'ชื่อผู้มอบฉันทะ',
          'shareholders': 662100
        },
        {
          'regisNumber': 4010008296,
          'refNumber': 1001,
          'agenda': 12,
          'subAgenda': '',
          'title': 'สมมติว่ามี ชื่อวาระ เพื่อทดสอบปริ้นเตอร์ ประจำปี 2561',
          'regisName': 'วีระ เดชธำรง โดยบริษัทหลักทรัพย์จัดการกองทุน กรุงไทย จำกัด (มหาชน)',
          'regisProxyName': 'ชื่อผู้มอบฉันทะ',
          'shareholders': 662100
        },
        {
          'regisNumber': 4010008296,
          'refNumber': 1001,
          'agenda': 13,
          'subAgenda': '',
          'title': 'สมมติว่ามี ชื่อวาระ เพื่อทดสอบปริ้นเตอร์ ประจำปี 2561',
          'regisName': 'วีระ เดชธำรง โดยบริษัทหลักทรัพย์จัดการกองทุน กรุงไทย จำกัด (มหาชน)',
          'regisProxyName': 'ชื่อผู้มอบฉันทะ',
          'shareholders': 662100
        }
      ]
    }
  },
  computed: {
    userData () {
      if (this.$cookies.isKey('shareholder_information')) {
        return JSON.parse(Decode.decode(this.$cookies.get('shareholder_information')))
      } else {
        return ''
      }
    },
    isQrExampleLastItemEnabled () {
      var targetTerm = true // เปิดปิด qrcode เเสดงความคิดเห็น
      return targetTerm !== '' && targetTerm
    },
    termYear () {
      if (this.$cookies.isKey('shareholder_termyear')) {
        return JSON.parse(Decode.decode(this.$cookies.get('shareholder_termyear')))
      } else {
        return ''
      }
    }
  },
  methods: {
    setLengthName (fullname) {
      if (fullname.length > 40) {
        fullname = fullname.slice(0, 40) + '...'
      }
      return fullname
    },
    setTableAlign (index) {
      if (index % 2 === 0) {
        return 'left'
      } else {
        return 'right'
      }
    },
    setTableStyle (index) {
      if (index % 2 === 0) {
        return ['tableLeft', {'tableTop': index === 0}]
      } else {
        return ['tableRight', {'tableTop': index === 1}]
      }
    },
    getmemberInfo () {
      this.axios.post(process.env.API + '/getShareholderInfo/' + this.termYear.term + '/' + this.termYear.year + '/' + this.getItemMember).then((response) => {
        var result = response.data
        this.memberInfo = result.info
        if (this.memberInfo.title === 'บริษัท') {
          this.memberInfo.fullname = 'บริษัท ' + this.memberInfo.companyname
        } else if (this.memberInfo.title === '') {
          this.memberInfo.fullname = this.memberInfo.firstname + ' ' + this.memberInfo.lastname
        } else {
          this.memberInfo.fullname = 'คุณ' + this.memberInfo.firstname + ' ' + this.memberInfo.lastname
        }
        this.memberInfo.proxyfullname = 'คุณ' + this.memberInfo.proxyname + ' ' + this.memberInfo.proxylastname
        this.getAgendaList()
      })
    },
    getAgendaList () {
      this.axios.get(process.env.API + '/getAgendaInYearUser/' + this.termYear.term + '/' + this.termYear.year + '/' + this.getItemMember).then((response) => {
        var result = response.data
        this.agendaVote = result
        if (this.agendaVote.length < 14) {
          var agendaLength = 14 - this.agendaVote.length
          for (var i = 0; i < agendaLength; i++) {
            this.agendaVote.push({agenda_index: '', agenda: '', short_title: '', agenda_id: ''})
          }
          if (this.isQrExampleLastItemEnabled && agendaLength > 0) {
            this.agendaVote[this.agendaVote.length - 1].isQrExample = true
          }
        }
        for (var j = 0; j < this.agendaVote.length; j++) {
          if (!this.agendaVote[j].isQrExample) {
            this.agendaVote[j].resultAgendaID = String('0000' + this.agendaVote[j].agenda_id).slice(-4)
          }
        }
      })
    },
    setQShare (number) {
      return number.toLocaleString(undefined, { minimumFractionDigits: 0 })
    }
  },
  mounted () {
    this.getItemMember = this.$route.params.id
    this.getmemberInfo()
  }
}
</script>

<style lang="css" scoped>
page[size="A4"] {
  background: white;
  width: 21cm;
  height: 29.7cm;
  display: block;
  margin: 0 auto;
  margin-bottom: 0.5cm;
  box-shadow: 0 0 0.5cm rgba(0,0,0,0.5);
}
@media print {
  body, page[size="A4"] {
    margin: 0;
    box-shadow: 0;
  }
}
table {
  border-collapse: collapse;
  margin-bottom: 13px;
}

table, th, td {
  /* border: 1px solid black; */
  border-left: 1px solid #ddd;
  border-bottom: 1px solid #ddd;
  border-right: 1px solid #ddd;
  /* table-layout: auto; */
}

th, td {
  padding-left: 10px;
  padding-right: 10px;
  text-align: center;
  font-size:9px;
}
span {
  padding-top: 9px;
  text-align: center;
  display: block;
  font-size:8px;
}
.img {
  margin-top: 5px;
  height: 40px;
}
.tablea {
  table-layout: auto;
  width: 211px;
  height: 10px;
}
.imgckbox {
  top:-5px;
  width:18px;
  height:18px;
  float: left;
  z-index:10;
  position:relative;
}
.tableblock {
  display: block;
}
.tableLeft{
  margin-left: 20px;
}
.tableRight{
  margin-right: 20px;
}
.tableTop{
  margin-top: 15px;
}
.qrcodeExampleTable {
  width: 390px;
}
.qrcodeExampleTable.tableRight {
  width: 370px;
  margin-left: auto;
  margin-right: 20px;
}

.qrcodeExampleCell {
  height: 145px;
  padding: 8px 10px;
  vertical-align: middle;
  box-sizing: border-box;
}
.qrcodeExampleContent {
  display: flex;
  flex-direction: row-reverse;
  align-items: center;
  justify-content: center;
  gap: 6px;
  min-height: 100%;
  width: 100%;
}
.qrcodeExampleImage {
  display: block;
  flex: 0 0 auto;
  width: 110px;
  height: auto;
  max-width: 100%;
}
.qrcodeExampleText {
  flex: 0 0 auto;
  font-size: 10px;
  font-weight: bold;
  line-height: 1;
  text-align: right;
  white-space: nowrap;
  max-width: none;
}
</style>



// WEBPACK FOOTER //
// src/components/Pdf/Proxytemplate.vue